/* oxlint-disable @typescript-eslint/consistent-type-assertions */

export type StoreSelectors<T> = {
  [K in keyof T]: () => T[K];
};

export function createStoreProxy<T>(getState: () => T): T {
  const proxy = new Proxy(
    {},
    {
      get(_target, prop) {
        const state = getState();

        return state[prop as keyof T];
      },
    },
  );

  return proxy as T;
}

export function createStoreSelectors<T>(): StoreSelectors<T> {
  const proxy = new Proxy(
    {},
    {
      get(_target, prop) {
        return (state: T) => state[prop as keyof T];
      },
    },
  );

  return proxy as StoreSelectors<T>;
}

export function resetOnMigration(): {} {
  return {};
}
